import { render } from "./TopPaginationComponent.vue?vue&type=template&id=450e7a47"
import script from "./TopPaginationComponent.vue?vue&type=script&lang=js"
export * from "./TopPaginationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__